export default __webpack_public_path__ + "static/media/half_blue_moon.9fe31f5a.png";